export enum CheckoutSection {
  DATA = 'DATA',
  CONTACT = 'CONTACT',
  PAYMENT = 'PAYMENT'
}
